export class ApiError extends Error {
  constructor(
    public status: number,
    public code: string,
    message: string,
    public data: Record<string, unknown> = {},
  ) {
    super(message);
  }
}

/** JSON API call. Errors carry the server's plain-language `message` when it has one; no response at all is status 0. */
export async function api<T = unknown>(path: string, init: { method?: string; body?: unknown } = {}): Promise<T> {
  let res: Response;
  try {
    res = await fetch(`/api${path}`, {
      method: init.method ?? (init.body !== undefined ? 'POST' : 'GET'),
      headers: init.body !== undefined ? { 'content-type': 'application/json' } : undefined,
      body: init.body !== undefined ? JSON.stringify(init.body) : undefined,
    });
  } catch {
    // No response at all: offline, DNS, or the connection dropped. Status 0 marks it for error states.
    throw new ApiError(0, 'network', 'Hoopoe can’t be reached. Check your connection, then try again.');
  }
  if (res.status === 204) return undefined as T;
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok)
    throw new ApiError(res.status, String(data.error ?? 'error'), String(data.message ?? 'Something went wrong. Try again.'), data);
  return data as T;
}
